export const selectAISearchReducer = (state) => state?.AISearchReducer;

export const selectAISearchData = (state) =>
    selectAISearchReducer(state)?.data || [];

export const selectAISearchFilters = (state) =>
    selectAISearchReducer(state)?.filters || null;

export const selectAISearchMessage = (state) =>
    selectAISearchReducer(state)?.message || null;

export const selectAISearchLoading = (state) =>
    selectAISearchReducer(state)?.pending || false;

export const selectAISearchError = (state) =>
    selectAISearchReducer(state)?.error || null;
